import { useQueryClient } from '@tanstack/vue-query'
import { computed, ref } from 'vue'

// Реактивное состояние токена
const token = ref<string | null>(null)
const isInitialized = ref(false)

// Инициализация токена при первом использовании
const initializeToken = () => {
    if (!isInitialized.value) {
        try {
            const savedToken = localStorage.getItem('token')
            token.value = savedToken ? JSON.parse(savedToken) : null
        } catch (error) {
            console.warn('Failed to parse token from localStorage:', error)
            token.value = null
        }
        isInitialized.value = true
    }
}

export const useAuth = () => {
    const queryClient = useQueryClient()

    // Инициализируем токен при первом вызове
    initializeToken()

    // Вычисляемые свойства
    const isAuthenticated = computed(() => {
        return !!token.value
    })

    // Методы для работы с токеном
    const setToken = (newToken: string) => {
        token.value = newToken
        localStorage.setItem('token', JSON.stringify(newToken))
    }

    const clearToken = () => {
        token.value = null
        localStorage.removeItem('token')
        queryClient.clear() // Очищаем весь кэш
    }

    // Простой logout без API вызова (для экстренных случаев)
    const logout = () => {
        clearToken()
    }

    // Инициализация - синхронизация с localStorage при изменениях в других вкладках
    const syncTokenFromStorage = () => {
        const storageToken = JSON.parse(localStorage.getItem('token') || 'null')
        if (storageToken !== token.value) {
            token.value = storageToken
        }
    }

    // Слушаем изменения в других вкладках
    window.addEventListener('storage', (e) => {
        if (e.key === 'token') {
            syncTokenFromStorage()
        }
    })

    return {
        token: computed(() => {
            return token.value
        }),
        isAuthenticated,
        isInitialized: computed(() => {
            return isInitialized.value
        }),
        setToken,
        clearToken,
        logout,
    }
}
